module.exports = __webpack_public_path__ + "media/images/svg/logo-6d1b102a39485792ac4994c37a6bd812.svg";